import React, { useState } from "react";
import {
  Button,
  Chip,
  Divider,
  TextField,
  Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const StepWebhook = ({ state, dispatch }) => {
  const [carregando, setCarregando] = useState(false);
  const [copiado, setCopiado] = useState("");

  const setCampo = (campo) => (e) =>
    dispatch({ type: "SET_CAMPO", campo, valor: e.target.value });

  const copia = (valor, qual) => {
    navigator.clipboard.writeText(valor);
    setCopiado(qual);
  };

  const configura = async () => {
    setCarregando(true);
    try {
      const { data } = await api.post("/whatsapp/oficial/webhook", {
        whatsappId: state.whatsappId,
        app_id: state.appId,
        app_secret: state.appSecret,
      });
      // `confirmado` prova que a Meta entrega NESTA conexao (callback URL bate
      // e o campo `messages` esta assinado). `inscrito` so diz que existe algum
      // app na WABA — criterio antigo, que dava verde para conexao que nunca
      // recebeu nada porque a WABA acumula apps de conexoes antigas.
      dispatch({ type: "SET_CAMPO", campo: "webhookVerificado", valor: data.confirmado });
      if (!data.confirmado && data.motivo) {
        toastError(data.motivo);
      }
    } catch (err) {
      toastError(err);
    }
    setCarregando(false);
  };

  const verifica = async () => {
    setCarregando(true);
    try {
      const { data } = await api.get(
        `/whatsapp/oficial/${state.whatsappId}/webhook-status`
      );
      // Consulta sem credencial de app nao confirma nada: so a chegada de uma
      // mensagem real promove a conexao a verificada.
      dispatch({
        type: "SET_CAMPO",
        campo: "webhookVerificado",
        valor: data.statusWebhook === "verified",
      });
    } catch (err) {
      toastError(err);
    }
    setCarregando(false);
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {i18n.t("whatsappOficialWizard.webhook.titulo")}
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {i18n.t("whatsappOficialWizard.webhook.descricao")}
      </Typography>

      <Typography variant="subtitle2" style={{ marginTop: 16 }}>
        {i18n.t("whatsappOficialWizard.webhook.automatico")}
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        label={i18n.t("whatsappOficialWizard.webhook.appId")}
        value={state.appId}
        onChange={setCampo("appId")}
      />
      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        type="password"
        label={i18n.t("whatsappOficialWizard.webhook.appSecret")}
        value={state.appSecret}
        onChange={setCampo("appSecret")}
      />
      <Button
        color="primary"
        variant="contained"
        disabled={carregando || !state.appId || !state.appSecret}
        onClick={configura}
      >
        {i18n.t("whatsappOficialWizard.webhook.configurar")}
      </Button>

      <Divider style={{ margin: "20px 0" }} />

      <Typography variant="subtitle2">
        {i18n.t("whatsappOficialWizard.webhook.manual")}
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        label={i18n.t("whatsappOficialWizard.webhook.url")}
        value={state.webhookUrl}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <Button size="small" onClick={() => copia(state.webhookUrl, "url")}>
              {copiado === "url"
                ? i18n.t("whatsappOficialWizard.webhook.copiado")
                : i18n.t("whatsappOficialWizard.webhook.copiar")}
            </Button>
          ),
        }}
      />
      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        label={i18n.t("whatsappOficialWizard.webhook.verifyToken")}
        value={state.verifyToken}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <Button size="small" onClick={() => copia(state.verifyToken, "vt")}>
              {copiado === "vt"
                ? i18n.t("whatsappOficialWizard.webhook.copiado")
                : i18n.t("whatsappOficialWizard.webhook.copiar")}
            </Button>
          ),
        }}
      />

      <div style={{ marginTop: 12 }}>
        <Button size="small" onClick={verifica} disabled={carregando}>
          {i18n.t("whatsappOficialWizard.webhook.verificar")}
        </Button>
        <Chip
          size="small"
          style={{ marginLeft: 8 }}
          color={state.webhookVerificado ? "primary" : "default"}
          label={
            state.webhookVerificado
              ? i18n.t("whatsappOficialWizard.webhook.verificado")
              : i18n.t("whatsappOficialWizard.webhook.aguardandoMensagem")
          }
        />
      </div>
    </div>
  );
};

export default StepWebhook;
